const MONITORING_SESSION_KEY = "recover_monitoring_session";

const getRecoverableSessions = () => {
  const session = localStorage.getItem(MONITORING_SESSION_KEY);
  if (session) return JSON.parse(session);
  return [];
};

const removeRecoverableSession = (jid) => {
  if (!jid) localStorage.setItem(MONITORING_SESSION_KEY, JSON.stringify([]));
  else {
    const sessions = getRecoverableSessions().filter((s) => s.jid !== jid);
    localStorage.setItem(MONITORING_SESSION_KEY, JSON.stringify(sessions));
  }
};

const setRecoverableSessions = ({ monitoringId, jid, parentStationState }) => {
  const existingSessions = getRecoverableSessions();
  localStorage.setItem(
    MONITORING_SESSION_KEY,
    JSON.stringify([
      ...existingSessions,
      {
        monitoringId,
        jid,
        parentStationState
      }
    ])
  );
};

const monitoringRestorer = {
  getRecoverableSessions,
  setRecoverableSessions,
  removeRecoverableSession
};

export default monitoringRestorer;
